<script lang="ts" setup>
import { toRefs } from 'vue';

type Emits = {
  (e: 'on-image-loaded'): void;
};
const emit = defineEmits<Emits>();

type Props = {
  src: string;
  width?: number;
  height?: number;
  level?: number;
  alt?: string;
};
const props = withDefaults(defineProps<Props>(), {
  width: 128,
  height: 180,
  level: 0,
});
const { src, width, height } = toRefs(props);
</script>

<template>
  <div class="stack-container" :style="`width: ${width}px; height: ${height}px`">
    <v-img
      v-if="level > 0"
      class="stack one elevation-4 rounded-sm"
      :src="src"
      :width="width"
      :height="height"
      :alt="alt"
      eager
      @load="emit('on-image-loaded')"
    >
      <template #error>
        <slot name="error"></slot>
      </template>
    </v-img>
    <v-img
      v-if="level > 0"
      class="stack two elevation-4 rounded-sm"
      :src="src"
      :width="width"
      :height="height"
      :alt="alt"
      eager
      @load="emit('on-image-loaded')"
    >
      <template #error>
        <slot name="error"></slot>
      </template>
    </v-img>
  </div>
</template>

<style scoped lang="scss">
.stack-container {
  position: relative;
  overflow: visible;
}

.stack {
  position: absolute;
}

.one {
  top: 0px;
  z-index: -1;
  transform: rotate(-4deg);
  transform-origin: 50% 50%;
}

.two {
  top: 0px;
  left: 0px;
  z-index: -2;
  transform: rotate(5deg);
  transform-origin: 60% 80%;
}
</style>
